module.exports = __webpack_public_path__ + "img/login8.b164f8c4.jpg";